@if (showPanel) {
  <div class="side-panel-container">
    <div class="side-panel">
      <img class="side-panel-img" [src]="panelData.image" alt="random image alt" />
      <div class="side-panel-text-container">
        <div class="panel-text">
          <h4 class="panel-header" [innerHTML]="panelData.header"></h4>
          @if (panelData.accountBalance !== undefined) {
            <p class="side-panel-header-span">{{ panelData.accountBalance }}</p>
          }
          @if (panelData.blurb) {
            <p class="panel-blurb">{{ panelData.blurb }}</p>
          }
          @if (panelData.bullets && panelData.bullets.length > -1 && !panelData.blurb) {
            <ul class="fa-ul panel-list">
              @for (bullet of panelData.bullets; track $index) {
                <li class="panel-bullet">
                  <i class="fa-solid fa-check"></i>
                  <p>{{ bullet.bullet }}</p>
                </li>
              }
            </ul>
          }
          <div class="side-panel-btn-container">
            <a
              [attr.aria-label]="panelData.ctaAriaLabel"
              [class.gs-link-btn]="!panelData.ctaIsLink"
              [href]="panelData.ctaLink"
            >
              {{ panelData.ctaLabel }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
}
